import { GlobalLocalStorageKey } from "src/types"

export function getLocalStorageCountryCodeSelection(): string | null {
  return localStorage.getItem(GlobalLocalStorageKey.CountryCodeSelection)
}

export function setLocalStorageCountryCodeSelection(countryCode: string): void {
  localStorage.setItem(
    GlobalLocalStorageKey.CountryCodeSelection,
    countryCode,
  )
}

export function removeLocalStorageCountryCodeSelection(): void {
  localStorage.removeItem(GlobalLocalStorageKey.CountryCodeSelection)
}
